import {resources} from "../../../../../../../core/models/resource/resources";

export const createTestingResultModalName: string = 'createTestingResultModal';
export const createTestingResultModalTitle: string = 'Создание результата тестирования';

export const testingResultResourceType = resources['testing-results'];
